import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuIcon, SearchIcon, HelpIcon, BellIcon, PlusIcon } from '../../icons';
import { getMyConfig } from '../../api/billing';
import { useWorkspace } from '../../contexts/WorkspaceContext';

// Topbar: mobile hamburger + placeholder search + action icons.
// Real search command palette and notifications будут позже (агент 04+).
export function Topbar({ onOpenMobileMenu }) {
  const navigate = useNavigate();
  const { current: workspace } = useWorkspace();
  const [billingMode, setBillingMode] = useState(null);

  useEffect(() => {
    let active = true;
    setBillingMode(null);
    getMyConfig(workspace?.slug)
      .then((config) => {
        if (active) {
          setBillingMode(config?.billing_mode === 'managed' ? 'managed' : 'paid');
        }
      })
      .catch(() => {
        if (active) setBillingMode(null);
      });
    return () => {
      active = false;
    };
  }, [workspace?.slug]);

  return (
    <header className="lk-topbar">
      <button
        type="button"
        className="lk-topbar__burger"
        onClick={onOpenMobileMenu}
        aria-label="Открыть меню"
      >
        <MenuIcon size={18} />
      </button>

      <div className="lk-topbar__crumbs">
        <b>Дашборд</b>
      </div>

      <button
        type="button"
        className="lk-topbar__search"
        aria-label="Открыть поиск"
        /* TODO(04-overview): wire Cmd+K command palette */
      >
        <SearchIcon size={14} />
        <span className="lk-topbar__search-placeholder">
          Найти сессию, телефон, страницу…
        </span>
        <span className="lk-topbar__kbd">⌘K</span>
      </button>

      <div className="lk-topbar__actions">
        <a href="/dashboard2" className="lk-btn lk-btn--secondary lk-btn--sm" title="Попробовать новый интерфейс">
          Попробовать новый интерфейс →
        </a>
        <button type="button" className="lk-topbar__icn-btn" title="Помощь" aria-label="Помощь">
          <HelpIcon size={16} />
        </button>
        <button
          type="button"
          className="lk-topbar__icn-btn"
          title="Уведомления"
          aria-label="Уведомления"
        >
          <BellIcon size={16} />
          <span className="lk-topbar__icn-btn-dot" />
        </button>
        {billingMode === 'paid' && (
          <button
            type="button"
            className="lk-btn lk-btn--primary lk-btn--sm"
            onClick={() => navigate('/billing')}
            title="Пополнить баланс"
          >
            <PlusIcon size={14} stroke={2} /> Пополнить
          </button>
        )}
      </div>
    </header>
  );
}
